module.exports = __webpack_public_path__ + "img/云稼集配-太阳码.76da8872.jpg";